'use client';

import dynamic from 'next/dynamic';
import type { ComponentType } from 'react';
import type { DaumPostcodeEmbedProps } from 'react-daum-postcode';

// react-daum-postcode 타입이 React 19 이전 전역 JSX.Element라 ComponentType에
// 할당되지 않는다(render(): JSX.Element). 런타임은 정상이며, 캐스트를 이 한 곳에 봉인한다.
export const DaumPostcodeEmbed = dynamic(
  () =>
    import('react-daum-postcode').then(
      (module) =>
        module.default as unknown as ComponentType<DaumPostcodeEmbedProps>,
    ),
  { ssr: false },
);
